import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import LandingSection from "../landingsection";

const testimonials = [
  {
    name: "Donna Wheaton",
    designation: "Top Player",
    image: "/images/top/item1.png",
    review:
      "This has been game changer and time saver for me, before this I had to waste so much time waiting to get into the game, start playing and even more when depositing or taking out my winnings, but now all of this is so quick and easy.",
  },
  {
    name: "Jacobs Anderson",
    designation: "Top Player",
    image: "/images/top/item2.png",
    review:
      "At first, I was confused like what the hell is this, but when I tried it for real, man, it's so easy, and it does make it easier to just play the games and not mess around waiting for a response from the chat.",
  },
  {
    name: "Rafuj Raihan",
    designation: "Top Player",
    image: "/images/top/item3.png",
    review:
      "So much better than before, no fuss, no muss, just straight into gaming and cashing in and out like a breeze.",
  },
];

const Section03 = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1800,
    center: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    // autoplaySpeed: 100,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1.5, slidesToScroll: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
    ],
  };

  return (
    <LandingSection
      title="What Players Say"
      description="Check out some reviews from other players in your community."
    >
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <Slider {...settings}>
            {testimonials.map((testimonial, index) => (
              <div key={index} className="px-2 ">
                <div className="testimonial-item  update-card bg_img d-flex flex-column h-[400px]">
                  <div className="testimonial-inner  flex-grow-1 d-flex flex-column">
                    <div className="testimonial-content flex-grow-1">
                      <div className="quote-icon">
                        <i className="las la-quote-left"></i>
                      </div>
                      <p>{testimonial.review}</p>
                    </div>
                    <div className="thumb-wrapper">
                      <div className="thumb">
                        <img src={testimonial.image} alt="top" />
                      </div>
                      <div className="content">
                        <h6 className="name">{testimonial.name}</h6>
                        <p className="designation">{testimonial.designation}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </LandingSection>
  );
};

export default Section03;
